import { component } from 'picoapp';
import OptionSelector from 'utils/option-selector';
import formatMoney from 'utils/format-money';

export default component(async () => {
  const init = (e) => {
    const { el } = e.detail;
    const id = el.getAttribute('id');
    const itemId = el.closest('[data-wk-item]').getAttribute('data-wk-item');
    const container = document.querySelector(`#wk-item-${itemId}`);

    const appmateSelectCallback = (variant) => {
      const product = window.Appmate.wk.getProduct(variant.product_id);

      if (variant) {
        window.Appmate.wk.updateItem(itemId, { selected_variant_id: variant.id });
      }

      let imageUrl = '';

      if (variant && variant.image) {
        imageUrl = window.Appmate.wk.filters.img_url(variant, '1000x');
      } else if (product) {
        imageUrl = window.Appmate.wk.filters.img_url(product, '1000x');
      }

      if (imageUrl) {
        container.querySelector('.wk-variant-image').setAttribute('src', imageUrl);
      }

      if (!product.hidden && variant && (variant.available || variant.inventory_policy === 'continue')) {
        const addToCart = container.querySelector('.wk-add-to-cart-custom');
        addToCart.removeAttribute('disabled');
        addToCart.classList.remove('disabled');
        addToCart.setAttribute('value', theme.strings.product.addToCart);

        if (parseFloat(variant.price) < parseFloat(variant.compare_at_price)) {
          container.querySelector('.wk-price-preview').innerHTML = `${formatMoney(variant.price * 100)} <del>${formatMoney(variant.compare_at_price * 100)}</del>`;
        } else {
          container.querySelector('.wk-price-preview').innerHTML = `${formatMoney(variant.price * 100)}`;
        }
      } else {
        let message = theme.strings.wishlist.unavailable;
        if (variant && !product.hidden) {
          message = theme.strings.wishlist.soldOut;
        }

        container.querySelector('.wk-add-to-cart-custom').classList.add('disabled');
        container.querySelector('.wk-add-to-cart-custom').setAttribute('disabled', 'disabled');
        container.querySelector('.wk-add-to-cart-custom').setAttribute('value', message);
        container.querySelector('.wk-price-preview').textContent = message;
      }
    };

    window.Appmate.wk.getItem(itemId).then((product) => {
      if (!product.variants[0].options) {
        product.variants.forEach((i) => {
          i.options = [i.option1];
          if (i.option2) i.options.push(i.option2);
          if (i.option3) i.options.push(i.option3);
        });
      }

      const selector = OptionSelector(`#${id}`, {
        data: product,
        onVariantSelected: appmateSelectCallback,
        enableHistoryState: false,
      });

      selector.selects.forEach((select) => {
        if (select.options.length < 2) {
          select.parentElement.style.display = 'none';
        }
      });

      appmateSelectCallback(product.variants[0], selector);

      // Add label if only one product option and it isn't 'Title'.
      if (product.options.length === 1 && product.options[0] !== 'Title') {
        window.Appmate.wk.$(container)
          .find('.selector-wrapper:first-child')
          .prepend(`<label>${product.options[0]}</label>`);
      }
    });
  };

  document.addEventListener('wishlistKing:options', init);
});
